/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the platform-browser/testing package.
 */
export * from './browser';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
